import { render, staticRenderFns } from "./alter.vue?vue&type=template&id=7ca1d980&scoped=true&"
import script from "./alter.vue?vue&type=script&lang=js&"
export * from "./alter.vue?vue&type=script&lang=js&"
import style0 from "./alter.vue?vue&type=style&index=0&id=7ca1d980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca1d980",
  null
  
)

export default component.exports